var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper", class: { "nav-open": _vm.$sidebar.showSidebar } },
    [
      _c("notifications"),
      _c(
        "side-bar",
        { attrs: { backgroundColor: _vm.colorBackground, id: "sidebar" } },
        [
          _c("mobile-menu"),
          _vm.menus.length > 0 && this.userLogged
            ? _c(
                "template",
                { slot: "links" },
                [
                  _vm.isMenuVisible("/operativa")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Envíos",
                              icon: "nc-icon nc-delivery-fast",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/envios")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Envíos",
                                    path: "/franquicia/envios",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/control")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Control",
                                    path: "/franquicia/control",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/rma")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "RMA",
                                    path: "/franquicia/rma",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/envios-agrupados")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Envíos Agrupados",
                                    path: "/franquicia/envios-agrupados",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/incoterms-sended")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Incoterms",
                                    path: "/franquicia/incoterms-sended",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/recogidas")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Recogidas",
                              icon: "nc-icon nc-pickup",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/recogidas/propias")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Propias",
                                    path: "/franquicia/recogidas/propias",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible(
                            "/franquicia/recogidas/otras-plazas"
                          )
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Otras plazas",
                                    path: "/franquicia/recogidas/otras-plazas",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/recogidas/partner")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Partner",
                                    path: "/franquicia/recogidas/partner",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible(
                            "/franquicia/recogidas/partner-programadas"
                          )
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Partner programadas",
                                    path: "/franquicia/recogidas/partner-programadas",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/entregas")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Entregas",
                              icon: "nc-icon nc-delivery",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/entregas/propias")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Propias",
                                    path: "/franquicia/entregas/propias",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/franquicia/kpis")
                    ? _c("sidebar-item", {
                        attrs: {
                          hideItem: _vm.ocultarItem,
                          link: {
                            name: "KPIs",
                            icon: "nc-icon nc-chart-bar-32",
                            path: "/franquicia/kpis",
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.isMenuVisible("/franquicia/incidencias/historico")
                    ? _c("sidebar-item", {
                        attrs: {
                          hideItem: _vm.ocultarItem,
                          link: {
                            name: "Gestión de Incidencias",
                            icon: "nc-icon nc-settings-tool-66",
                            path: "/franquicia/incidencias/historico",
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.isMenuVisible("/franquicia/expedientes")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Expedientes",
                              icon: "nc-icon nc-single-copy-04",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/expedientes/medidas")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Pesos y Medidas",
                                    path: "/franquicia/expedientes/medidas",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/expedientes/servicios")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Garantías de servicio",
                                    path: "/franquicia/expedientes/servicios",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible(
                            "/franquicia/expedientes/siniestros"
                          )
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Siniestros",
                                    path: "/franquicia/expedientes/siniestros",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/importaciones")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Importaciones",
                              icon: "nc-icon nc-cloud-upload-94",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/importaciones")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Envios",
                                    path: "/franquicia/importaciones",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/importacionesRma")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "RMA",
                                    path: "/franquicia/importacionesRma",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/facturacion")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Facturación",
                              icon: "nc-icon nc-paper-2",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/valoraciones")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Control de Valoraciones",
                                    path: "/franquicia/valoraciones",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/albaranes")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Albaranes",
                                    path: "/franquicia/albaranes",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/facturas")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Facturas",
                                    path: "/franquicia/facturas",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/tarifas")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Tarifas",
                                    path: "/franquicia/tarifas",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/notificaciones")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Notificaciones",
                                    path: "/franquicia/notificaciones",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/documentacion")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Documentación",
                                    path: "/franquicia/documentacion",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/gestion_de_cartera")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Gestión de Cartera",
                              icon: "nc-icon nc-credit-card",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/efectos")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Efectos",
                                    path: "/franquicia/efectos",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/remesas")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Remesas",
                                    path: "/franquicia/remesas",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/logistica")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Logística",
                              icon: "nc-icon nc-app",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/logistica/almacenes")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Almacenes",
                                    path: "/logistica/almacenes",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/articulos")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Artículos",
                                    path: "/logistica/articulos",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/kits")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Kits",
                                    path: "/logistica/kits",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/ordenes-entrada")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Ordenes entrada",
                                    path: "/logistica/ordenes-entrada",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/ordenes-salida")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Ordenes salida",
                                    path: "/logistica/ordenes-salida",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/stock")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Stock",
                                    path: "/logistica/stock",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/stock-history")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Historial stock",
                                    path: "/logistica/stock-history",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/valoraciones")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Valoraciones",
                                    path: "/logistica/valoraciones",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/tarifas")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Tarifas",
                                    path: "/logistica/tarifas",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/logistica/importaciones")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Importaciones",
                                    path: "/logistica/importaciones",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/clientes")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Clientes",
                              icon: "nc-icon nc-circle-09",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/clientes")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Listado de Clientes",
                                    path: "/franquicia/clientes",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMenuVisible("/franquicia")
                    ? _c(
                        "sidebar-item",
                        {
                          attrs: {
                            hideItem: _vm.ocultarItem,
                            link: {
                              name: "Franquicia",
                              icon: "nc-icon nc-single-02",
                              path: "*",
                            },
                          },
                        },
                        [
                          _vm.isMenuVisible("/franquicia/misDatos")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Mis Datos",
                                    path: "/franquicia/misDatos",
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.isMenuVisible("/franquicia/usuarios")
                            ? _c("sidebar-item", {
                                attrs: {
                                  hideItem: _vm.ocultarItem,
                                  link: {
                                    name: "Usuarios",
                                    path: "/franquicia/usuarios",
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "main-panel" },
        [
          _c("top-navbar"),
          _c("dashboard-content", { on: { click: _vm.toggleSidebar } }),
          _c("content-footer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }